export const ITR_setGlobalOverlayLoaderReducer = {
  ITR_setGlobalOverlayLoader: (state, action) => {
    state.globalOverlayLoader = action.payload;
  },
};
